var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('i',{staticClass:"empty__icon fe fe-alert-circle"}),_c('div',{staticClass:"empty__text"},[_vm._v(_vm._s(_vm.message))]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }